module.exports = "\n    <select name=\"timezone\" class=\"form-control form-accede\" ng-init=\"$ctrl.initial\" ng-model=\"$ctrl.selected\" ng-change=\"$ctrl.onSelect({timezone: $ctrl.selected})\"\n            ng-disabled=\"$ctrl.disabled\" >\n      <option value=\"\" disabled>Seleccione una Zona horaria</option>\n      <option ng-repeat=\"timezone in $ctrl.timezones\" value=\"{{ timezone.timezones }}\">\n        {{ timezone.timezones }}\n      </option>\n    </select>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/timezones/timezones.html
// module id = 485
// module chunks = 0